import server from "../utils/request.js";
import qs from "qs";
import { dict } from "../utils/base";

import axios from "axios"; //调用本地JSON文件用

const adminURL = dict.ADMIN_URL;

export function fetchPermission () {
    return server.get('./static/permission.json');
}
export function login () {
    return server.get('/static/login.json');
}




// WEBPACK FOOTER //
// ./src/api/permission.js